export const USER_SCOPE_CACHE_KEY = 'gtm_user_scope_v1';
export const MAPPED_GTM_EVENTS = [
  'user_created',
  'user_email_verified',
  'user_kyc_completed',
  'user_kyc_started',
  'user_logged_in',
] as const;
